module.exports = __webpack_public_path__ + "static/media/lb_05 (1).725165f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb_05 (1).jpg
// module id = 2008
// module chunks = 2